import { render, staticRenderFns } from "./afrInfoAi.vue?vue&type=template&id=5434d160&"
import script from "./afrInfoAi.vue?vue&type=script&lang=js&"
export * from "./afrInfoAi.vue?vue&type=script&lang=js&"
import style0 from "./afrInfoAi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5434d160')) {
      api.createRecord('5434d160', component.options)
    } else {
      api.reload('5434d160', component.options)
    }
    module.hot.accept("./afrInfoAi.vue?vue&type=template&id=5434d160&", function () {
      api.rerender('5434d160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/ams/afrInfoAi.vue"
export default component.exports